import React, { useEffect, useState } from 'react';
import { Button, Modal, Stack, Form } from 'react-bootstrap';
import useCommonStore from 'store/common';
import { useGetSharePostUsersQuery } from 'services';
import { dataLimits } from 'constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import ShareList from 'components/ShareList/ShareList';
import useDebounce from 'hooks/useDebounce';
import useTranslate from 'hooks/useTranslate';
import ExternalShareBtn from 'components/Common/ExternalShareBtn';
import { useLocation, useNavigate } from 'react-router-dom';
import { APP_BASE_URL } from 'constants';
import { APP_NAME } from 'constants';

const SharePost: React.FC<any> = () => {
	const { translate } = useTranslate();
	const navigate = useNavigate();
	const location = useLocation();
	const { modalConfig = {}, hideCommonModal }: any = useCommonStore((state) => state);
	const [userData, setUserData] = useState({
		currentPage: 1,
		limit: dataLimits.sharePostModal,
		order: 'DESC',
		keyword: '',
		id: modalConfig?.id,
	});

	const { data: { docs = [], meta = {} } = [], refetch }: any = useGetSharePostUsersQuery(userData);
	const [locationQry, setLocationQry] = useState<string | null>(null);
	const [shareUrl, setShareUrl] = useState('');
	const debouncedQry = useDebounce(locationQry, 300);

	useEffect(() => {
		if (debouncedQry !== null) {
			refetch();
		}
	}, [debouncedQry]);

	useEffect(() => {
		if (modalConfig?.id && modalConfig?.visible) {
			if (modalConfig?.id && modalConfig?.visible) {
				setShareUrl(`${window.location.origin}${APP_BASE_URL}/feed-detail/${modalConfig.id}`);
				// setShareUrl(`https://mymeetingdesk.com:6300${APP_BASE_URL}/feed-detail/${modalConfig.id}`);
			}
		}
	}, [modalConfig?.id, modalConfig?.visible]);

	const handleClose = () => {
		// Clear data before closing
		setUserData((prev) => ({
			...prev,
			currentPage: 1,
			keyword: '',
		}));
		setLocationQry(null);
		setShareUrl('');
		hideCommonModal();
	};

	const loadMoreFunc = () => {
		setUserData((prev) => ({
			...prev,
			limit: prev.limit * prev.currentPage + 1,
		}));
	};

	const handleOnChange = (e: any) => {
		const value = e.target.value.length === 0 ? '' : e.target.value;
		setLocationQry(value);
		setUserData((prev) => ({
			...prev,
			keyword: value,
		}));
	};

	return (
		<Modal.Body className="p-30 pe-0">
			<Button
				className="close-btn rounded-circle border-0 fw-bold position-absolute"
				onClick={handleClose}
			>
				<i className="ri-close-line"></i>
			</Button>
			<Stack className="share-post gap-2 gap-sm-3">
				<div className="share-post-head my-2 d-flex align-items-center justify-content-between">
					<h4 className="fw-bold mb-0">{translate('Modal.shareThis')}</h4>
					<ExternalShareBtn url={shareUrl} title={APP_NAME} />
				</div>
				<Form.Group className="user-search mw-100">
					<div className="position-relative w-100">
						<i className="ri-search-line position-absolute"></i>
						<Form.Control
							className="rounded-pill"
							type="search"
							placeholder={translate('PlaceHolder.searchPeople')}
							onChange={handleOnChange}
							value={userData.keyword ?? ''}
						/>
					</div>
				</Form.Group>
				<div id="my-share-list" className="users-list" style={{ overflow: 'auto' }}>
					<InfiniteScroll
						dataLength={meta?.totalDocs || 0}
						next={loadMoreFunc}
						hasMore={meta?.hasNextPage}
						loader={docs.length >= 1 && <h4>Loading...</h4>}
						scrollableTarget="my-share-list"
						scrollThreshold="300px"
						refreshFunction={loadMoreFunc}
						pullDownToRefreshThreshold={50}
						pullDownToRefreshContent={
							<h3 style={{ textAlign: 'center' }}>
								&#8595; {translate('Common.pullDownToRefresh')}
							</h3>
						}
						releaseToRefreshContent={
							<h3 style={{ textAlign: 'center' }}>
								&#8593; {translate('Common.releaseToRefresh')}
							</h3>
						}
					>
						{docs?.length > 0 ? (
							docs?.map((res: any, index: any) => (
								<div key={`shared1-${res?.userId}-${index}`}>
									<ShareList data={res} index={index} />
								</div>
							))
						) : (
							<div className="pe-4">
								<Stack className="posted-job-box">{translate('Common.noDataFound')} </Stack>
							</div>
						)}
					</InfiniteScroll>
				</div>
			</Stack>
		</Modal.Body>
	);
};

export default SharePost;
